exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".space-after[data-v-53cc84dd] {\n  margin-bottom: 1.5rem;\n}\n", ""]);

// exports
